import React from 'react';

export interface FieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  hint?: string;
  inputMode?: 'text' | 'numeric' | 'decimal';
  maxLength?: number;
  /** Renders as a password field when true. */
  secret?: boolean;
  autoFocus?: boolean;
}

/** Labelled single-line input with the console's focus treatment. */
export const Field: React.FC<FieldProps> = ({
  label,
  value,
  onChange,
  placeholder,
  hint,
  inputMode = 'text',
  maxLength,
  secret = false,
  autoFocus = false,
}) => (
  <label className="block">
    <span className="mb-1.5 block text-sm font-medium text-[#333333]">{label}</span>
    <input
      type={secret ? 'password' : 'text'}
      value={value}
      inputMode={inputMode}
      maxLength={maxLength}
      autoFocus={autoFocus}
      placeholder={placeholder}
      onChange={(event) => onChange(event.target.value)}
      className="h-12 w-full rounded-xl border border-[#E0E0E0] bg-white px-4 text-[#333333] outline-none transition-colors placeholder:text-[#999999] focus:border-[#D4A054] focus:ring-2 focus:ring-[#D4A054]/30"
    />
    {hint && <span className="mt-1.5 block text-xs text-[#666666]">{hint}</span>}
  </label>
);

export default Field;
